import React, { useState, useEffect } from "react";
import ConfirmButton from "../../../components/ConfirmButton";
import TextInput from "../../../components/TextInput";
import SelectInput from "../../../components/SelectInput";
import SelectForm from "../../../components/SelectForm";
import SelectionForm from "../../../components/SelectionForm";
/*
label="Módulo"
id="module"
options={moduleOptions}
value={module}
onChange={(e) => setModule(e.target.value)}
error={module === "" ? "Por favor, seleccione un módulo" : ""}
showErrors={showErrors}
*/
function PermissionForm({ onSubmit, permission , moduleList, moduleInfo}) {
  
  const actions = {
    "CREATE": "Crear",
    "READ": "Ver",
    "UPDATE": "Editar",
    "DELETE": "Eliminar"
  }
  const [name, setName] = useState(permission?.name || "");
  const [description, setDescription] = useState(permission?.description || "");
  const [selectedModule, setSelectedModule] = useState(permission?.module._id || "");
  const [selectedFeature, setSelectedFeature] = useState(permission?.feature || "");
  const [action, setAction] = useState(permission?.action || "");
  const [modules, setModules] = useState([]);
  const [featureOptions, setFeatureOptions] = useState({})
  const [features, setFeatures] = useState(moduleInfo);
  const [isFormValid, setIsFormValid] = useState(false);
  const [showErrors, setShowErrors] = useState(false);

  useEffect(() => {
    console.log(name !== "" && selectedModule !== "" &&
      selectedFeature !== "" && action !== "")
      console.log(name,selectedFeature, selectedModule,action)
    setIsFormValid(
      name !== "" && selectedModule !== "" &&
      selectedFeature !== "" && action !== ""
    ); // The form is valid if the name is not empty
  }, [name, selectedModule, selectedFeature, action]);

  useEffect(() => {
    let temp = {... moduleList}
    delete temp[""]
    console.log(moduleInfo)
    setModules(temp)
  }, [moduleList,moduleInfo]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (name.trim() === "" || selectedModule === "") {
      setShowErrors(true);
      return;
    }
    let info = { 
      name, 
      description, 
      module: selectedModule,
      moduleName: modules[selectedModule],
      feature: selectedFeature, 
      action };
    onSubmit({ ...permission, ...info });
  };

  useEffect(() => {
    if (selectedModule) {
      let selectedFeatures = [...features[selectedModule]]
      let newFeatures = {}
      for (let feature of selectedFeatures){
        newFeatures[feature.key] = feature.name
      }
      setFeatureOptions({...newFeatures});
  
      console.log(newFeatures)
    } 
  }, [selectedModule]);
  useEffect(()=> {
    console.log(featureOptions, selectedFeature)

  }, [featureOptions])
  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col gap-y-2"
    >
    
      <TextInput
        label="Nombre del Permiso"
        id="nombre"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      
        <SelectionForm
          text="Módulo"
          options={Object.keys(modules)}
          mask={modules}
          onChange={option => {setSelectedModule(option); setSelectedFeature("")}}
          value={selectedModule}
          AppendClassName=""
        />

     <div className="w-full -mt-5">
      <SelectionForm
          text="Funcionalidad"
          options={Object.keys(featureOptions)}
          mask={featureOptions}
          onChange={option => setSelectedFeature(option)}
          value={selectedFeature}
          AppendClassName=""
        />
     </div>
      <div className="w-full -mt-5">
      <SelectionForm
          text="Acción"
          options={Object.keys(actions)}
          mask={actions}
          onChange={option => setAction(option)}
          value={action}
          AppendClassName=""
        />
      </div>
      <div className="w-full -mt-5">
        <TextInput
          label="Descripción del Permiso"
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          isTextArea={true}
        />
      </div>
      

      <ConfirmButton isConfirmed={isFormValid} />
    </form>
  );
}

export default PermissionForm;
